import React, { useEffect, useState, useContext, useRef } from "react"
import * as Yup from "yup"
import { Formik } from "formik"
import {
  IconButton,
  Grid,
  Card,
  Typography,
  Divider,
  Tooltip,
  Checkbox,
  InputAdornment,
  FormHelperText,
  Switch,
} from "@material-ui/core"
import GeoLocation from "./GeoLocation"
import {
  CheckCircleIcon,
  Hash,
  Phone,
  MapPin,
  Mail,
  Edit,
  Slash,
  PercentageIcon,
  UserIcon,
  StoreIcon,
  PlaceIcon,
} from "@iconsGallery"
import * as Utils from "@utils"
import _, { functions, isUndefined, keys } from "lodash"
import * as ServiceAPI from "@services"
import * as Adm from "@adm"
import { useTranslation } from "react-i18next"
import * as constantsAPI from "@constants"
import { ConfirmationDialog } from "../ConfirmationDialog"
import { OperationHoursKit } from "../OperationHoursKit"
import { InfoOutlined, Label } from "@material-ui/icons"
import userApi from "../../services/user/api"
import { useHistory } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { object } from "@storybook/addon-knobs"
import {
  operatingHrs,
  getDefaultStoreEntryAuthList,
  getRevertStoreEntryAuthArrayList,
  getTransformObjecToArray,
  defaultStoreEntryAuthObj,
  getTransformArrayToObject,
  getDetailViewMapping,
} from "./fixture"
import { DashboardContext } from "@utils"
import { useStyles, FormMainWrapper, TextField } from "./styles"
import alertApiMethods from "../../services/user/api"
import { renderPaymentInfo } from "./renderProps"
const { APIEndPoint: { API_END_POINTS = {} } = {} } = constantsAPI || {}

const IS_MAP_ENABLE = false

const getTenantAddressSafe = () => {
  try {
    const raw = localStorage.getItem("tenantAddress")
    if (!raw) return {}
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === "object" ? parsed : {}
  } catch (e) {
    return {}
  }
}

function LocationAddress(props) {
  const {
    getStoreTypeList = [],
    data = {},
    setAllowPrompt = () => {},
    isWriteAllowed = false,
    isTablet = false,
    locationType = {},
    setLocationType = () => {},
    storageUnitList = [],
    survCameraList = [],
    alertGeneraionList = [],
    locationTypeList = [],
    timeZoneList = [],
    paymentType = {},
    paymentGatewayList = [],
    accountType = {},
    storeId = "",
    setData = [],
    sendBackData,
    isView = "create",
    accountList = [],
    storeUnitListUrl = "",
  } = props
  const tempDropdownList = {
    list: [],
    totalDocs: "",
    nextPage: null,
  }
  const initialDataState = {
    page: 1,
    showMore: false,
    limit: 50,
    filter: [],
    searchTerm: "",
  }
  let copyPaymentType = paymentType
  const classes = useStyles()
  const initialStoreTypeDataState = {
    page: 1,
    showMore: false,
    limit: 5,
    filter: [],
    searchTerm: "",
  }
  let selectedStoreTypeList = React.useRef([])
  const [storeTypeDataState, setStoreTypeDataState] = React.useState(
    initialStoreTypeDataState
  )
  const [
    searchTermSurveillanceCameraMulti,
    setSearchTermSurveillanceCameraMulti,
  ] = React.useState("")
  const [
    disabledDataSurveillanceCameraMulti,
    setDisabledDataSurveillanceCameraMulti,
  ] = React.useState([])
  const [
    filteredSurveillanceCameraMultiList,
    setFilteredSurveillanceCameraMultiList,
  ] = React.useState([])
  const { locationId, storeType = "", store_mode = "" } = data || {}
  const [getAccNameLoader, setAccNameLoader] = useState(false)
  const [edit, setEdit] = useState(false)
  const [loading, setLoading] = useState(false)
  const [alert, setAlert] = useState(false)
  const [alertMessage, setAlertMessage] = useState("")
  const [alertType, setAlertType] = useState("")
  const { t } = useTranslation()
  const [isAnyChanges, setAnyChanges] = React.useState(false)
  const [countryOpen, setCountryOpen] = React.useState(false)
  const [stateOpen, setStateOpen] = React.useState(false)
  const [isPhoneField, setPhoneField] = useState({ phoneCountryCode: "" })
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false)
  const [updateData, setUpdateData] = useState({})
  const [selectedSurvCamera, setSelectedSurvCamera] = useState("")
  const [isCameraChanged, setIsCameraChanged] = useState(false)
  const [locationTypeError, setLocationTypeError] = useState(false)
  const [paymentTypeError, setPaymentTypeError] = useState(false)
  const [accountTypeError, setAccountTypeError] = useState(false)
  const [locationSizeError, setLocationSizeError] = useState(false)
  const [storeTypeOpen, setStoreTypeOpen] = useState(false)
  const [cameraOpen, setCameraOpen] = useState(false)
  const [storageOpen, setStorageOpen] = useState(false)
  const [storeScheduleList, setStoreScheduleList] = useState([])
  const [getStoreEntryAuthList, setStoreEntryAuthList] = useState([])
  const [dropDownScheduleList, setDropdownScheduleList] = useState(
    tempDropdownList
  )
  const [dropdownScheduleDataState, setDropdownScheduleDataState] = useState(
    initialDataState
  )
  const [scheduleOpen, setScheduleOpen] = useState(false)

  const [getStorageAddress, setStorageAddress] = useState({})

  const [getPHConfigOpen, setPHConfigOpen] = React.useState(false)
  const [getPH_GWConfigOpen, setPH_GWConfigOpen] = React.useState(false)
  const [getPH_ANConfigOpen, setPH_ANConfigOpen] = React.useState(false)

  const [getPHConfigList, setPHConfigList] = React.useState([
    { id: 1, name: "DigitMart" },
    { id: 2, name: "Client" },
  ])
  const [getPH_GWConfigList, setPH_GWConfigList] = React.useState([])
  const [getPH_ANConfigList, setPH_ANConfigList] = React.useState([
    { id: 1, name: "Arun" },
    { id: 2, name: "Cash Free" },
    { id: 3, name: "Cash Free" },
  ])

  let history = useHistory()
  const userProfileDetails =
    useSelector((state) => state.adminReducer.userProfileDetails) || {}
  const userPermAttr =
    useSelector((state) => state.adminReducer.userKeycloakAttributes) || {}
  const isStorageModuleAllowed = Utils.JSUtils.getReadWritePermissions(
    { readAccessPath: "Master Data.Storage - Read" },
    userPermAttr
  ).isReadAllowed

  const [closeDateError, setCloseDateError] = useState(false)
  const [daysArrState, setDaysArrState] = useState([])
  const [daysArrError, setDaysArrError] = useState([])
  const [timeArrState, setTimeArrState] = useState([])
  const [daysError, setDaysError] = useState([])
  const { countryList, setCountryList } = useContext(DashboardContext) || {}
  const [getUserCityList, setUserCityList] = useState([])
  const [userCityOpen, setUserCityOpen] = useState(false)
  const [getSelectedCamera, setSelectedCamera] = useState("")
  const [getSelectedStoreType, setSelectedStoreType] = useState("")
  let defaultCountry = Utils?.JSUtils?.getActiveCountryName?.() || "USA"
  let defaultCountryCode = Utils?.JSUtils?.getActiveCountryCode?.() || "US"
  const [getStatesList, setStatesList] = useState([])
  const [getCityList, setCityList] = useState([])
  const [getStatesOpen, setStatesOpen] = useState(false)
  const [getCityOpen, setCityOpen] = useState(false)

  const fetchCurrencyCountry = (propsKit = {}) => {
    let defaultCountryCodeSelected =
      Utils?.JSUtils?.getActiveCountryCode?.() || "US"
    if (!API_END_POINTS?.getDefaultCountrySelected) return
    ServiceAPI.getStoreCommonData(
      API_END_POINTS.getDefaultCountrySelected(defaultCountryCodeSelected)
    )
      .then((res) => {
        const list = Array.isArray(res?.data) ? res.data : []
        setPH_GWConfigList(
          list.map((itm) => {
            return { id: itm?._id, name: itm?.payment_name }
          })
        )
      })
      .catch((err) => {
        console.log("fetchCurrencyCountry Error", err)
      })
  }

  const fetchPaymentAccount = async (propsKit = {}) => {
    const { getPaymentGateway = "Stripe", setFieldValue = () => "" } = propsKit
    setAccNameLoader(true)
    let realmId = localStorage.getItem("X-KC-Realm-ID")
    ServiceAPI.getStoreWithHeadersData(
      `${
        API_END_POINTS.getPaymentMethodDropdown
      }?payment_type=${getPaymentGateway}&is_realm=${false}`,
      {
        headers: {
          "tenant-id": localStorage.getItem("tenantId"),
        },
      }
    )
      .then((response) => {
        let { data = {} } = response || {}
        let list = []

        data?.map((o, index) =>
          list.push({ id: index, name: o.account_name, mode: o?.mode })
        )
        let lcList = [...list]

        setPH_ANConfigList(lcList)
        setAccNameLoader(false)
      })
      .catch((error) => {
        console.log("error", error)
        setPH_ANConfigList([])
        setAccNameLoader(false)
        setFieldValue("paymentAccountName", "skip")
      })
  }

  useEffect(() => {
    setAccNameLoader(true)
    if (isView === "create") {
      setEdit(true)
      fetchCurrencyCountry()
    } else {
      setEdit(false)
    }
  }, [locationId])

  const doFilterUpdateStoreTypeList = (resp) => {
    var surveillanceCameraList = _.isEmpty(resp)
      ? []
      : resp?.surveillance_cameras || []

    let surveillanceCameraListKit = []
    if (!_.isEmpty(surveillanceCameraList)) {
      setFilteredSurveillanceCameraMultiList(
        surveillanceCameraList?.map((itm) => itm?.name || "")
      )
      setDisabledDataSurveillanceCameraMulti([])
    }
  }

  const onUpdateCity = (list) => {
    setCityList(list)
  }

  useEffect(() => {
    const onUpdateCityData = () => {
      /* ONLY_UAE_CITY */
      let editStateData = _.get(data, "locationAddress.region", "")
      const country =
        Utils?.JSUtils?.getActiveCountryName?.() ||
        getTenantAddressSafe()?.country ||
        "USA"
      if (Utils?.JSUtils?.getIsUAEFlag(country)) {
      } else {
        if (!_.isEmpty(editStateData)) {
          const [_statesData = {}] = (getStatesList || []).filter(
            (stateItm) => stateItm.name === editStateData
          )
          const { cities = [] } = _statesData || {}
          let citiesKit = cities?.map((itm) => {
            return { ...itm, id: itm.name }
          })
          onUpdateCity(citiesKit)
        }
      }
    }
    if (data) {
      doFilterUpdateStoreTypeList(data)
      if (_.isEmpty(data) === false) {
        let zipCode = data?.locationAddress?.postalcode
        let countryCode = data?.locationAddress?.country_code

        onUpdateCityData()
        fetchCityList(zipCode, countryCode)
        fetchCurrencyCountry()
        fetchPaymentAccount({
          getPaymentGateway: _.get(data, "payment_provider", ""),
        })
      }
    }
  }, [data])

  useEffect(() => {
    const country =
      Utils?.JSUtils?.getActiveCountryName?.() ||
      getTenantAddressSafe()?.country ||
      "USA"
    if (Utils?.JSUtils?.getIsUAEFlag(country)) {
      /* US NOT REQUIRED */
    } else {
      getEditLoadStateAndCity(data)
    }
    fetchScheduleList()
  }, [])

  const fetchCityList = (zipCode, countryCode) => {
    let flag = zipCode && countryCode
    if (Utils?.JSUtils?.getIsUAECodeFlag(countryCode)) {
      flag &&
        ServiceAPI.fetchZipcodeDetails(zipCode, countryCode)
          .then((response) => {
            if (response && response.data && response.data.length > 0) {
              const cityList = response.data.map((option) => {
                return { id: option.city, name: option.city }
              })
              setUserCityList(cityList)
            } else {
              setUserCityList([])
            }
          })
          .catch((error) => {
            setUserCityList([])
          })
    }
  }

  async function fetchScheduleList() {
    await alertApiMethods.getAlertScheduleAll().then((resp) => {
      let scheduleList = []
      _.map(resp?.data, (x) =>
        scheduleList.push({
          id: x?.schedule_id || "",
          name: x?.name || "",
        })
      )
      let data = scheduleList
      let list = _.map(data, (x) => ({ id: x?.id, name: x?.name }))
      setStoreScheduleList(list)
    })
  }

  const onGlobalUpdate = () => {
    setAnyChanges(true)
  }

  const updateLocationDetails = async (body) => {
    setAlert(false)
    let response = await ServiceAPI.fetchStoreCommonData(
      locationId?.length > 0
        ? API_END_POINTS.updateLocation
        : API_END_POINTS.addLocation,
      body
    )

    if (response?.data?.status === "success") {
      await setAlertType(_.get(response, "data.status", "success"))
      await setAlertMessage(
        _.get(response, "data.message", "information modified successfully")
      )
      await setAlert(true)
      await setLoading(false)
      await setAllowPrompt(false)
      setTimeout(() => {
        history.push(storeUnitListUrl)
        // history.push(`/${userProfileDetails?.roleType}/master-data/locations`)
      }, 2000)
    } else {
      setLoading(false)
      await setAlert(true)
      await setAlertType("error")
      await setAlertMessage(response?.response?.data?.message)
    }
  }

  /**
   * @Get_Business_Hours_data
   */
  const getBusinessHrs = (locationData) => {
    let errData = { errFrom: "", errTo: "" }
    const businessHrs = locationData?.business_hrs
    if (
      _.isEmpty(locationData) ||
      !Array.isArray(businessHrs) ||
      _.isEmpty(businessHrs)
    ) {
      return operatingHrs
    }
    return _.forEach(businessHrs, function (item) {
      const times = item?.times
      if (Array.isArray(times) && times.length > 0) {
        let errorItem = []
        _.forEach(times, function () {
          errorItem.push({ ...errData })
        })
        return (item.errorsArr = errorItem)
      }
      return (item.errorsArr = [])
    })
  }

  const storeEntryAuthSource =
    _.get(data, "storeEntryAuthentication") || defaultStoreEntryAuthObj
  const defaultStoreEntryAuthentication = getTransformObjecToArray(
    _.isObject(storeEntryAuthSource) && !Array.isArray(storeEntryAuthSource)
      ? storeEntryAuthSource
      : defaultStoreEntryAuthObj
  )

  const tenantAddressDefaults = getTenantAddressSafe()
  let isAllowPhoneNumber =
    _.get(data, "phoneNumber.number", "") === "" ? false : true
  let basicInitialValues = {
    allowPhoneNumber: isAllowPhoneNumber,
    location: _.get(data, "locationId", ""),
    locationName: _.get(data, "locationName", ""),
    phoneNumber:
      _.get(data, "phoneNumber.countryCode", "") +
      (_.get(data, "phoneNumber.number", "") === 0
        ? ""
        : _.get(data, "phoneNumber.number", "")),
    schedule_id: _.get(data, "alert_schedule_id", ""),
    storeEntryAuthentication: defaultStoreEntryAuthentication,
    emailAddress: _.get(data, "locationSupportEmail", ""),
    locationManager: _.get(data, "locationManager", ""),
    assistantManager: _.get(data, "assistantManager", ""),
    cvThreshold: _.get(data, "cv_least_threshold", ""),
    maxStoreOccupancy: _.get(data, "max_occupancy_limit_of_store", ""),
    storeType: _.get(data, "store_mode", ""),
    surveillanceCamera: _.get(data, "surveillance_cameras", ""),
    line1: _.get(data, "locationAddress.line1", ""),
    line2: _.get(data, "locationAddress.line2", ""),
    postalcode: _.get(data, "locationAddress.postalcode", ""),
    state: _.get(data, "locationAddress.region", ""),
    country: _.get(
      data,
      "locationAddress.country",
      Utils?.JSUtils?.getActiveCountryName?.() ||
        tenantAddressDefaults?.country ||
        "US"
    ),
    addressCountryCode: _.get(
      data,
      "locationAddress.country_code",
      Utils?.JSUtils?.getActiveCountryCode?.() || "US"
    ),
    city: _.get(data, "locationAddress.city", ""),
    countryCode: _.get(data, "phoneNumber.countryCode", ""),
    latitude: _.get(data, "locationGeoPoint.coordinates[1]", ""),
    longitude: _.get(data, "locationGeoPoint.coordinates[0]", ""),
    returnPolicy: _.get(data, "returnPolicy", ""),
    locationType: _.get(data, "locationType", ""),
    locationSize: _.get(data, "locationSize", {}),
    locationSizeLength: _.get(data, "locationSize.lengthValue", ""),
    locationSizeWidth: _.get(data, "locationSize.widthValue", ""),
    locationSizeHeight: _.get(data, "locationSize.heightValue", ""),
    storageUnitId: _.get(data, "storageunit_ids[0]", ""),
    isStorageunitAddress: _.get(data, "isStorageunitAddress", false),
    isActive: _.get(data, "isActive", true),
    openDate: _.get(data, "openDate", ""),
    closeDate: _.get(data, "closeDate", ""),
    locationTimezone: _.get(data, "locationTimezone", ""),
    business_hrs: getBusinessHrs(data),
    payment_handler: _.get(data, "payment_handler", "DigitMart"),
    payment_provider:
      _.get(data, "payment_handler", "DigitMart") === "Client"
        ? "skip"
        : _.get(data, "payment_provider", ""),
    client_url:
      _.get(data, "payment_handler", "DigitMart") === "DigitMart"
        ? isView === "Create"
          ? ""
          : "https://www.skip.com"
        : _.get(data, "client_url", ""),
    paymentAccountName:
      _.get(data, "payment_handler", "DigitMart") === "Client"
        ? "skip"
        : _.get(data, "paymentAccountName", ""),
    pre_auth_amount:
      _.get(data, "payment_handler", "DigitMart") === "Client"
        ? 1
        : _.get(data, "pre_auth_amount", 1),
    order_expiry_in_days:
      _.get(data, "payment_handler", "DigitMart") === "Client"
        ? 1
        : _.get(data, "order_expiry_in_days", 1),
    refund_window_in_days:
      _.get(data, "payment_handler", "DigitMart") === "Client"
        ? 1
        : _.get(data, "refund_window_in_days", 1),
  }

  let initialValues = { ...basicInitialValues }

  if (localStorage.getItem("tenantPaymentConfigEnable") === "true") {
    let paymentInitialValues = {
      paymentAccountName: !_.isEmpty(data)
        ? {
            id: _.get(data, "paymentAccountName", ""),
            name: _.get(data, "paymentAccountName", ""),
            payment_provider: _.get(data, "payment_provider", ""),
            mode: _.get(data, "paymentMode", ""),
          }
        : "",
      preAuthAmountRequired: !_.isEmpty(data?.pre_auth_amount),
      order_expiry_in_days: _.get(data, "order_expiry_in_days", ""),
      refund_window_in_days: _.get(data, "refund_window_in_days", ""),
    }

    initialValues = { ...initialValues, ...paymentInitialValues }
  }

  if (basicInitialValues.addressCountryCode === "IN") {
    initialValues["GSTNumber"] = _.get(data, "gst_number", "")
  }

  const storeEntryAuthSchema = Yup.array()
    .required("Store Entry Auth is required")
    .min(1, "At least one option must be selected")
    .test(
      "exclusive-freeEntry",
      "Free Entry cannot be selected with other options",
      (value) => {
        if (!Array.isArray(value)) return false
        const hasFreeEntry = value.includes("freeEntry")
        const hasOthers = value.some((item) => item !== "freeEntry")
        return !(hasFreeEntry && hasOthers)
      }
    )

  let mandatoryValidation = {
    location: Yup.string()
      .required("Enter Store Number")
      .matches("^[A-Za-z0-9_@./#+-]*$", "Enter valid Store Number")
      .min(1, "Store Number can be of min-1 max-255 characters")
      .max(255, "Store Number can be of min-1 max-255 characters")
      .strict(true),
    latitude: Yup.number()
      .required("Enter Latitude Number")
      .min(-90, "latitude can be min(-90) max(90) value")
      .max(90, "latitude can be min(-90) max(90) value"),
    longitude: Yup.number()
      .required("Enter Longitude Number")
      .min(-180, "longitude can be min(-180) max(180) value")
      .max(180, "longitude can be min(-180) max(180) value"),
    locationName: Yup.string()
      .required(`Enter Store Name`)
      .matches("^[a-zA-Z0-9_-\\s]+$", "Enter valid Store Name")
      .min(1, "Store Name can be of min-1 max-255 characters")
      .max(255, "Store Name can be of min-1 max-255 characters")
      .strict(true),
    phoneNumber: Yup.string()
      .notRequired()
      // .required("Select phoneNumber")
      .min(10)
      .matches(
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
      ),
    schedule_id: Yup.string().required("Select Schedule Name"),
    locationManager: Yup.string()
      .required(`Enter Store Manager Name`)
      .min(1, "Store Manager Name can be of min-1 max-255 characters")
      .max(255, "Store Manager Name can be of min-1 max-255 characters")
      .matches(
        /^[aA-zZ\s]+$/,
        "Only alphabets are allowed for Store Manager Name"
      )
      .strict(true),
    assistantManager: Yup.string()
      .min(1, "Assistant Manager Name can be of min-1 max-255 characters")
      .max(255, "Assistant Manager Name can be of min-1 max-255 characters")
      .matches(
        /^[aA-zZ\s]+$/,
        "Only alphabets are allowed for Assistant Manager"
      )
      .strict(true),
    emailAddress: Yup.string()
      .email("Enter valid Email")
      .min(1, "Email can be of min-1 max-255 characters")
      .max(255, "Email can be of min-1 max-255 characters")
      .required("Enter Email Id")
      .strict(true),
    cvThreshold: Yup.number()
      .required("Enter CV Threshold Number")
      .integer("Enter a valid integer")
      .min(1, "Value must be between 1 and 100")
      .max(100, "Value must be between 1 and 100"),
    maxStoreOccupancy: Yup.number()
      .typeError("Only Numbers are allowed for Max Store Occupancy")
      .required("Enter Max Store Occupancy Number")
      .integer("Enter a valid integer")
      .min(1, "Value must be between 1 and 100")
      .max(100, "Value must be between 1 and 100"),
    // storeEntryAuthentication: Yup.array()
    //   .min(1, "Please select at least one option")
    //   .required("Store Entry Auth is required"),
    storeEntryAuthentication: storeEntryAuthSchema,
    storeType: Yup.object().required("Store Type is required"),
    surveillanceCamera: Yup.mixed().required("Surveillance Camera is required"),
    line1: Yup.string()
      .required(`Enter Address line 1`)
      .min(1, "Address line 1 can be of min-1 max-255 characters")
      .max(255, "Address line 1 can be of min-1 max-255 characters")
      .strict(true),
    state: Yup.string().required(`Select State from Zipcode`).strict(true),
    city: Yup.string().required(`Select City from Zipcode`).strict(true),
    postalcode: Yup.string().when("country", {
      is: (country) => Utils?.JSUtils?.getIsUAEFlag(country),
      then: (schema) =>
        schema
          .required("Enter Zipcode")
          .trim("No spaces allowed at the start or end")
          .strict(true)
          .min(4, "Zipcode can be of min-4 max-10 characters")
          .max(10, "Zipcode can be of min-4 max-10 characters"),
      otherwise: (schema) => schema.notRequired(),
    }),
    returnPolicy: Yup.string()
      .required(`Enter Return Policy`)
      .min(1, "Return Policy can be of min-1 max-200 characters")
      .max(200, "Return Policy can be of min-1 max-200 characters")
      .strict(true),
    locationSizeLength: Yup.string().required("Enter Length"),
    locationSizeWidth: Yup.string().required("Enter Width"),
    locationSizeHeight: Yup.string().required("Enter Height"),
    openDate: Yup.string().required("Select Open Date"),
    locationTimezone: Yup.string().required("Select Time Zone"),
    pre_auth_amount: Yup.number()
      .required("Enter PreAuth Amount")
      // .integer("Enter a valid integer")
      .min(0, "Value must be between 0 and 1000")
      .max(1000, "Value must be between 0 and 1000"),

    payment_provider: Yup.string().required("Select Payment Provider"),
    client_url: Yup.string()
      .required("Select Payment Provider")
      .trim("No spaces allowed at the start or end")
      .strict(true)
      .matches(
        /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
        "Enter correct url"
      ),
    paymentAccountName: Yup.string().required("Select Account Name"),
    business_hrs: Yup.array()
      .test("Required", "Atleast Add one date", function (item) {
        let dateFlag = true
        let selectedDays = _.filter(item || [], "selected")
        if (selectedDays.length === 0) {
          dateFlag = false
        }
        return dateFlag
      })
      .test("", "", function (item) {
        let dateFlag = true
        _.forEach(item || [], function (dataItem) {
          const errorsArr = dataItem?.errorsArr
          Array.isArray(errorsArr) &&
            errorsArr.length > 0 &&
            _.forEach(errorsArr, function (errItem) {
              if (errItem?.errFrom !== undefined && errItem?.errFrom !== "") {
                dateFlag = false
              }
            })
        })
        return dateFlag
      }),
  }

  let paymentValidation = {}

  if (basicInitialValues.addressCountryCode === "IN") {
    mandatoryValidation["GSTNumber"] = Yup.string()
      .required("Enter GST-Number")
      .matches(/^[A-Z0-9]+$/, "Enter capital letters and numbers only")
      .min(1, "GST-Number must be at least 1 character long")
      .max(10, "GST-Number must be at most 10 characters long")
  }

  let validationSchema = { ...mandatoryValidation, ...paymentValidation }

  const getStateAPI = ({ countryCode = "", cbk = () => "" }) => {
    Utils?.JSUtils?.getStateList()
      .then((res) => {
        cbk({ res })
      })
      .catch((err) => {
        cbk({ res: err })
      })
  }

  const getEditLoadStateAndCity = () => {
    getStateAPI({
      cbk: (propsKit) => {
        let statesData =
          propsKit?.res?.map((itm) => {
            return { ...itm, name: itm.state, id: itm.state }
          }) || []
        setStatesList(statesData)
      },
    })
  }

  return (
    <div>
      <Card
        style={{
          width: "100%",
          boxShadow:
            "0px 0px 0px rgba(63, 63, 68, 0.05), 0px 1px 2px rgba(63, 63, 68, 0.15)",
          borderRadius: "8px",
        }}
      >
        <Adm.BackdropOverlay open={loading} />

        <>
          <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            validationSchema={Yup.object().shape(validationSchema)}
            onSubmit={async (values, { resetForm }) => {
              setAlert(false)
              const phoneNumberValue = values?.phoneNumber || ""
              const countryCodeValue = values?.countryCode || ""
              let phoneNumberOnly = String(phoneNumberValue).slice(
                String(countryCodeValue).length
              )
              phoneNumberOnly = phoneNumberOnly === "" ? "" : phoneNumberOnly

              let countryCodeOnly =
                phoneNumberOnly === "" ? "" : countryCodeValue

              let newArr = []
              _.forEach(values.business_hrs, function (dd) {
                let GGData = {
                  day: dd.day,
                  selected: dd.selected,
                  times: dd.times,
                }
                newArr.push(GGData)
              })
              const providersWithPreAuth = [
                "Stripe",
                "Nayax",
                "FreedomPay",
                "Nown",
                "ABC",
              ]

              let body = {
                locationId: values.location,
                locationName: _.trim(values.locationName),
                locationManager: _.trim(values.locationManager),
                assistantManager: _.trim(values.assistantManager),
                locationSupportEmail: values.emailAddress,
                phoneNumber: {
                  countryCode: values.allowPhoneNumber ? countryCodeOnly : "",
                  number: values.allowPhoneNumber ? phoneNumberOnly : "",
                },
                returnPolicy: _.trim(values.returnPolicy),
                locationHierarchy: "",
                locationSize: {
                  lengthValue: values?.locationSizeLength || 0,
                  widthValue: values?.locationSizeWidth || 0,
                  heightValue: values?.locationSizeHeight || 0,
                },
                locationAddress: {
                  line1: _.trim(values.line1),
                  line2: _.trim(values.line2),
                  postalcode: values.postalcode,
                  city: values.city.trim(),
                  region: values.state,
                  country: values.country,
                  country_code: values?.addressCountryCode,
                },
                locationGeoPoint: {
                  type: "Point",
                  coordinates: [
                    parseFloat(values.longitude) || 0,
                    parseFloat(values.latitude) || 0,
                  ],
                },
                locationType: {
                  id: locationTypeList[1]?.id,
                  name: locationTypeList[1]?.name,
                  code: locationTypeList[1]?.code,
                },
                storeType: {
                  id: "AS",
                  name: "Autonomous Store",
                },
                storageunit_ids:
                  locationId?.length > 0
                    ? undefined
                    : !isStorageModuleAllowed
                    ? []
                    : values?.storageUnitId?.length > 0
                    ? [values?.storageUnitId]
                    : [],
                cv_least_threshold: values?.cvThreshold,
                max_occupancy_limit_of_store: values?.maxStoreOccupancy,
                Validation_limit_of_store: values?.multiCheckboxValidation,
                surveillance_cameras: values?.surveillanceCamera,
                store_mode: values?.storeType,
                openDate: values?.openDate,
                closeDate: values?.closeDate ? values?.closeDate : "",
                locationTimezone: values?.locationTimezone,
                business_hrs: newArr,
                alert_schedule_id: values?.schedule_id,
                isAddressVerified: false,
                isActive: values?.isActive,
                payment_handler: values?.payment_handler,
                payment_provider: values?.payment_provider,
                paymentAccountName: values?.paymentAccountName,
                paymentMode: values?.paymentMode || data?.paymentMode || "",
                client_url: values?.client_url,
                order_expiry_in_days: values?.order_expiry_in_days,
                refund_window_in_days: values?.refund_window_in_days,
                storeEntryAuthentication: getTransformArrayToObject(
                  values?.storeEntryAuthentication
                ),
              }
              let paymentPayLoad = {}
              if (
                localStorage.getItem("tenantPaymentConfigEnable") === "true"
              ) {
                paymentPayLoad = {
                  paymentAccountName: values?.paymentAccountName?.name,
                  payment_provider:
                    values?.paymentAccountName?.payment_provider,
                  paymentMode: values?.paymentAccountName?.mode,
                  order_expiry_in_days: values?.order_expiry_in_days,
                  refund_window_in_days: values?.refund_window_in_days,
                }
                if (values?.country === "IN") {
                  paymentPayLoad["gst_number"] = values?.GSTNumber
                }
              }
              if (values?.addressCountryCode === "IN") {
                paymentPayLoad["gst_number"] = values?.GSTNumber
              }
              if (body["paymentAccountName"] === "skip") {
                body["paymentAccountName"] = _.isEmpty(getPH_ANConfigList)
                  ? ""
                  : "none"
              }
              if (body["payment_provider"] === "skip") {
                body["payment_provider"] =
                  values?.addressCountryCode === "IN" ? "CashFree" : "Stripe"
              }
              if (providersWithPreAuth.includes(body?.payment_provider)) {
                body.pre_auth_amount = values?.pre_auth_amount
              }
              if (body["client_url"] === "https://www.skip.com") {
                body["client_url"] = ""
              }

              delete body["storageUnitId"]
              delete body["alcoholTradingHrs"]
              delete body["businessHrs"]
              delete body["paymentMethodType"]

              await setLoading(true)
              setOpenConfirmationDialog(false)
              let payLoad = { ...body, ...paymentPayLoad }
              updateLocationDetails(payLoad)
            }}
          >
            {({
              errors,
              touched,
              values,
              handleBlur,
              handleChange,
              handleSubmit,
              setFieldValue,
              resetForm,
              setFieldError,
            }) => {
              // const handleDropdownChangeSurveillanceCameraMulti = (val) => {
              //   var selectedStores = []
              //   _.map(val, (value, index) => {
              //     let objVal = _.find(survCameraList, function (o) {
              //       return o?.name === value
              //     })
              //     selectedStores.push(objVal)
              //   })
              //   setFieldValue(
              //     "surveillanceCamera",
              //     selectedStores?.length > 0 ? selectedStores : ""
              //   )
              //   selectedStoreTypeList.current = val
              //   setFilteredSurveillanceCameraMultiList(val)
              //   onGlobalUpdate()
              // }
              const handleDropdownChangeSurveillanceCameraMulti = (val) => {
                const selectedValues = Array.isArray(val) ? val : []
                let finalSelectedValues = []
                // If user selects "None", clear all others
                if (selectedValues.includes("None")) {
                  // If "None" is the last clicked value
                  const lastSelected = selectedValues[selectedValues.length - 1]
                  if (lastSelected === "None") {
                    finalSelectedValues = ["None"]
                  } else {
                    // User selected something else while "None" existed → remove "None"
                    finalSelectedValues = selectedValues.filter(
                      (v) => v !== "None"
                    )
                  }
                } else {
                  finalSelectedValues = selectedValues
                }
                const selectedStores = finalSelectedValues
                  .map((value) =>
                    _.find(survCameraList, (o) => o?.name === value)
                  )
                  .filter(Boolean)
                setFieldValue(
                  "surveillanceCamera",
                  selectedStores.length > 0 ? selectedStores : ""
                )
                selectedStoreTypeList.current = finalSelectedValues
                setFilteredSurveillanceCameraMultiList(finalSelectedValues)
                onGlobalUpdate()
              }

              const handleDropdownSearchTermSurveillanceCameraMulti = (
                searchVal
              ) => {
                setStoreTypeDataState((c) => ({
                  ...c,
                  filter:
                    searchVal === ""
                      ? []
                      : [
                          {
                            field: "locationId",
                            operator: "contains",
                            value: searchVal,
                          },
                        ],
                  searchTerm: searchVal,
                  showMore: false,
                  page: 1,
                  limit: 5,
                }))
              }
              const handleShowMore = async (label) => {
                const nxtPage = survCameraList && survCameraList?.nextPage
                setStoreTypeDataState((c) => ({
                  ...c,
                  limit: 5,
                  page: nxtPage,
                  showMore: true,
                }))
              }

              const displayPhoneNumber =
                String(values?.phoneNumber || "").slice(
                  String(values?.countryCode || "").length
                ).length === 0
                  ? "-"
                  : values?.phoneNumber
              const handleKeyPress = (e, type) => {
                if (type === "number") {
                  if (e.which === 32) {
                    e.preventDefault()
                  }
                } else {
                  if (e.which === 32 && e.target.value === "") {
                    e.preventDefault()
                  }
                }
              }
              const storeTypeList = [
                { label: "Digit Mart", value: "digit_mart" },
                { label: "Digit Mart X", value: "digit_mart_x" },
              ]

              const handleCountry = (e, value) => {
                if (value !== null) {
                  setFieldValue("state", "")
                  onGlobalUpdate()
                } else {
                  setFieldValue("state", "")
                }
              }

              const handleState = (e, value) => {
                if (value !== null) {
                  setAllowPrompt(true)
                }
                setFieldValue("state", value)
                onGlobalUpdate()
              }

              const countryInputChange = () => {
                setFieldValue(
                  "country",
                  values?.country === ""
                    ? props?.defaultCountry
                    : values?.country
                )
              }

              const ZipCodeOnVerifyCB = (args) => {
                const {
                  status,
                  zipcode,
                  state,
                  cityList,
                  byDefaultValue,
                } = args

                setFieldValue("postalcode", zipcode)

                if (byDefaultValue) {
                  setUserCityList(cityList)
                } else {
                  if (status === "success") {
                    setUserCityList(cityList)
                    setFieldValue("state", state, "")
                    let [city] = cityList
                    setFieldValue("city", city, "")
                    setFieldError("state", "")
                    setFieldError("city", "")
                  } else {
                    setFieldValue("city", "")
                    setFieldValue("state", "")
                  }
                }
              }

              const ZipCodeOnChangeCB = ({ zipcode, byDefaultValue }) => {
                if (!byDefaultValue) {
                  setAnyChanges(true)
                  setFieldValue("city", "")
                  setFieldValue("state", "")
                  setUserCityList([])
                  setFieldValue("postalcode", zipcode)
                }
              }

              const handleDateChange = (date, type) => {
                type === "openDate"
                  ? setFieldValue("openDate", date)
                  : setFieldValue("closeDate", date)
              }

              const handleTimeZoneChange = (e, value) => {
                setFieldValue("locationTimezone", value)
              }

              const stateInputChange = () => {
                setFieldValue(
                  "state",
                  values?.state === "" ? props?.defaultState : values?.state
                )
              }

              const onChangeZipcode = async (props) => {
                setLoading(false)
                var zipCode = props?.target?.value
                let countryName = values?.country || defaultCountry
                const [_list] = countryList.filter(
                  (itm) => itm?.name === countryName
                )
                if (zipCode?.length >= 5) {
                  await setLoading(true)
                  let response = await ServiceAPI.fetchZipcodeDetails(
                    zipCode,
                    _list?.id
                  )
                  if (response?.data && response?.data.length > 0) {
                    const cityList =
                      response?.data?.map((option) => {
                        return { id: option?.city, name: option?.city }
                      }) || []
                    setUserCityList(cityList)
                    setFieldValue("city", _.get(response, "data[0].city", ""))
                    setFieldValue("state", _.get(response, "data[0].state", ""))
                  } else {
                    setFieldValue("city", "")
                    setFieldValue("state", "")
                    setUserCityList([])
                  }
                  await setLoading(false)
                } else {
                  setFieldValue("city", "")
                  setFieldValue("state", "")
                  setUserCityList([])
                }
              }

              const fetchStorageUnitById = async (storeageId) => {
                await setLoading(true)
                let response = await userApi.getStorageUnitById(`${storeageId}`)
                if (response?.status === 200) {
                  await setLoading(false)
                }
              }

              const handleCustomCloseRedirect = () => {
                setOpenConfirmationDialog(false)
                setFieldValue("surveillanceCamera", getSelectedCamera)
                setAnyChanges(true)
              }

              const handleCustomCloseStoreTypeRedirect = () => {
                setOpenConfirmationDialog(false)
                setFieldValue("storeType", getSelectedStoreType) // set earlier via setSelectedStoreType(val)
                setAnyChanges(true)
              }

              let scheduleIdWithName = ""

              if (
                storeScheduleList?.length > 0 &&
                values &&
                values?.schedule_id
              ) {
                const [_x = {}] = storeScheduleList.filter((itm) => {
                  return itm?.id === values?.schedule_id
                })
                scheduleIdWithName = _x?.name
              }

              const renderStoreEntryAuthUI = ({ edit = false }) => {
                return (
                  <Grid
                    item
                    lg={3}
                    md={3}
                    sm={6}
                    xs={6}
                    className={classes.divider}
                    key={JSON.stringify(
                      getDefaultStoreEntryAuthList({
                        edit,
                        values,
                        check: values?.storeType,
                      })
                    )}
                  >
                    <Typography variant="h5" className={classes.textHeader1}>
                      {`Store Entry Authentication`}
                      <span style={{ color: "red" }}>{edit ? "*" : ""} </span>
                    </Typography>
                    {edit ? (
                      <Adm.MultiCheckbox
                        options={getDefaultStoreEntryAuthList({
                          edit,
                          values,
                          check: values?.storeType,
                        })}
                        name="storeEntryAuthentication"
                        error={Boolean(
                          touched.storeEntryAuthentication &&
                            errors.storeEntryAuthentication
                        )}
                        helperText={errors.storeEntryAuthentication}
                        onBlur={handleBlur}
                        onCheck={(innerProps) => {
                          setAnyChanges(true)
                          setFieldValue(
                            "storeEntryAuthentication",
                            getRevertStoreEntryAuthArrayList(innerProps)
                          )
                        }}
                      />
                    ) : (
                      <Typography className={classes.text}>
                        {getDetailViewMapping(
                          values?.storeEntryAuthentication
                        ) || "Not Selected"}
                      </Typography>
                    )}
                  </Grid>
                )
              }
              return (
                <>
                  <ConfirmationDialog
                    openConfirmationDialog={openConfirmationDialog}
                    setOpenConfirmationDialog={setOpenConfirmationDialog}
                    handleCustomCloseRedirect={handleCustomCloseRedirect}
                    popupTitle="Are you Sure?"
                    deleteContent={
                      getSelectedCamera?.name !== "None" ? (
                        <span>
                          <h3>
                            You are about to change the surveillance camera for
                            this store
                          </h3>{" "}
                          Existing camera configuration will remain same,
                          <br /> You will need to set up new configurations
                        </span>
                      ) : (
                        <span>
                          {" "}
                          <h3>
                            You are about to remove the surveillance camera for
                            this store
                          </h3>{" "}
                          Existing camera configuration will remain the same
                        </span>
                      )
                    }
                  />
                  <FormMainWrapper
                    onSubmit={handleSubmit}
                    style={{ paddingBottom: "10px" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        height: "30px",
                        position: "relative",
                        marginBottom: 35,
                        justifyContent: "space-between",
                        alignItems: "center",
                        paddingTop: "20px",
                      }}
                      id="id-store-mobile-heading-addon"
                    >
                      <Typography
                        variant="h5"
                        style={{
                          paddingLeft: "10px",
                          fontWeight: "700",
                          fontSize: "15px",
                        }}
                      >
                        <IconButton>
                          <StoreIcon />
                        </IconButton>
                        {`STORE INFORMATION`}
                      </Typography>
                      {edit ? (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Adm.ButtonUI
                            typeView={"secondary"}
                            title="RESET"
                            // title="CANCEL"
                            onClick={() => {
                              storeId && setEdit(false)
                              setAnyChanges(false)
                              resetForm()
                              let savedList = []
                              sendBackData.surveillance_cameras.map((elem) => {
                                savedList.push(elem.name)
                              })
                              console.log("save", savedList)
                              if (
                                _.isEqual(
                                  savedList,
                                  filteredSurveillanceCameraMultiList
                                )
                              ) {
                                setFilteredSurveillanceCameraMultiList(
                                  filteredSurveillanceCameraMultiList
                                )
                              }
                              setFilteredSurveillanceCameraMultiList(savedList)
                              setAllowPrompt(false)
                            }}
                          />

                          <Adm.ButtonUI
                            typeView={"primary"}
                            title="SAVE"
                            type="submit"
                            onClick={() => {
                              setAnyChanges(false)
                            }}
                            style={{
                              padding: "9px",
                              pointerEvents: `${
                                isAnyChanges ? "unset" : "none"
                              }`,
                              color: `${
                                isAnyChanges ? "var(--white)" : "#000"
                              }`,
                              borderColor: `${
                                isAnyChanges ? "var(--white)" : "#CCC"
                              }`,
                              backgroundColor: `${
                                isAnyChanges ? "var(--primaryColor)" : "#CCC"
                              }`,
                            }}
                          />
                          {/* <Tooltip title="Cancel" placement="top">
                            <IconButton
                              onClick={() => {
                                storeId && setEdit(false)
                                setAnyChanges(false)
                                resetForm()
                                setAllowPrompt(false)
                              }}
                              style={{ padding: "9px" }}
                            >
                              <Slash style={{ height: "20px", color: "red" }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Save" placement="top">
                            <IconButton
                              type="submit"
                              onClick={() => {
                                setAnyChanges(false)
                              }}
                              style={{
                                padding: "9px",
                                pointerEvents: `${
                                  isAnyChanges ? "unset" : "none"
                                }`,
                              }}
                            >
                              <CheckCircleIcon
                                style={{
                                  color: `${isAnyChanges ? "#4CAF50" : "#CCC"}`,
                                }}
                              />
                            </IconButton>
                          </Tooltip> */}
                        </div>
                      ) : (
                        <>
                          <Adm.ButtonUI
                            typeView={"primary"}
                            title="EDIT"
                            aria-label="delete"
                            type="button"
                            disabled={isWriteAllowed === true ? false : true}
                            onClick={() => {
                              setEdit(true)
                            }}
                            style={{
                              padding: "9px",
                            }}
                          />
                          {/* <Tooltip title="Edit" placement="top">
                            <IconButton
                              disabled={isWriteAllowed === true ? false : true}
                              aria-label="delete"
                              onClick={() => {
                                setEdit(true)
                              }}
                              size="small"
                              style={{
                                padding: "9px",
                              }}
                            >
                              <Edit style={{ height: "20px" }} />
                            </IconButton>
                          </Tooltip> */}
                        </>
                      )}
                    </div>

                    <>
                      <Grid
                        container
                        direction="row"
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        xl={12}
                      >
                        <Grid
                          item
                          lg={3}
                          md={3}
                          sm={6}
                          xs={6}
                          className={classes.divider}
                          id="id-store-mobile-view-addon"
                        >
                          <Typography
                            variant="h5"
                            className={classes.textHeader1}
                          >
                            {"Store Type"}
                            <span style={{ color: "red" }}>
                              {edit ? "*" : ""}{" "}
                            </span>
                          </Typography>
                          {edit ? (
                            <>
                              {/* <>{JSON.stringify(getStoreTypeList)}</> */}
                              <div style={{ width: "100%", paddingLeft: 20 }}>
                                <Adm.DropdownFilter
                                  disabled={
                                    !_.isEmpty(store_mode) ? true : false
                                  }
                                  style={{
                                    width: "calc(100% - 14px)",
                                    backgroundColor: !_.isEmpty(store_mode)
                                      ? "#E0E0E0"
                                      : null,
                                  }}
                                  list={getStoreTypeList}
                                  popupOpen={storeTypeOpen}
                                  setPopupOpen={setStoreTypeOpen}
                                  onChangeEvent={(e, val) => {
                                    setAnyChanges(true)
                                    setFieldValue("storeType", val)
                                    setFieldValue(
                                      "storeEntryAuthentication",
                                      defaultStoreEntryAuthentication
                                    )
                                  }}
                                  defaultValue={values?.storeType}
                                  selectedValue={values?.storeType}
                                  onBlur={handleBlur}
                                  disableClearable={true}
                                  classNameTextField={
                                    classes.autoCompleteHeight
                                  }
                                  placeholder={"Select Store Type"}
                                  touchedControl={touched?.storeType}
                                  errorControl={errors?.storeType}
                                />
                              </div>
                            </>
                          ) : (
                            <Typography className={classes.textemail}>
                              {values.storeType?.name || "Choose Store Type"}
                            </Typography>
                          )}
                        </Grid>

                        <Grid
                          item
                          lg={3}
                          md={6}
                          sm={6}
                          xs={12}
                          className={classes.divider}
                        >
                          <Typography
                            variant="h5"
                            className={classes.textHeader1}
                          >
                            {`Store Number `}
                            <span style={{ color: "red" }}>
                              {edit ? "*" : ""}{" "}
                            </span>
                          </Typography>
                          {edit ? (
                            <TextField
                              type="text"
                              defaultValue={values.location}
                              value={values.location}
                              variant="outlined"
                              name="location"
                              placeholder="Store Number"
                              error={Boolean(
                                touched.location && errors.location
                              )}
                              helperText={touched.location && errors.location}
                              onBlur={handleBlur}
                              onChange={(props) => {
                                if (values.location !== null) {
                                  setAllowPrompt(true)
                                }
                                props.persist()
                                handleChange(props)
                                onGlobalUpdate()
                              }}
                              onKeyPress={(e) => handleKeyPress(e, "number")}
                              size="small"
                              className={classes.textField}
                              disabled={locationId?.length > 0 ? true : false}
                              style={{
                                backgroundColor:
                                  locationId?.length > 0 ? "#E0E0E0" : null,
                              }}
                            />
                          ) : (
                            <Typography className={classes.text}>
                              {values.location || "-"}
                            </Typography>
                          )}
                        </Grid>

                        <Grid
                          item
                          lg={3}
                          md={6}
                          sm={6}
                          xs={12}
                          className={`${
                            isTablet ? classes.noDivider : classes.divider
                          }`}
                        >
                          <Typography
                            variant="h5"
                            className={classes.textHeader1}
                          >
                            Store Name{" "}
                            <span style={{ color: "red" }}>
                              {edit ? "*" : ""}{" "}
                            </span>
                          </Typography>
                          {edit ? (
                            <TextField
                              defaultValue={values.locationName}
                              value={values.locationName}
                              variant="outlined"
                              name="locationName"
                              autoComplete="off"
                              placeholder="Store Name"
                              error={Boolean(
                                touched.locationName && errors.locationName
                              )}
                              helperText={
                                touched.locationName && errors.locationName
                              }
                              onKeyPress={(e) => handleKeyPress(e, "text")}
                              onBlur={handleBlur}
                              onChange={(props) => {
                                if (values.locationName !== null) {
                                  setAllowPrompt(true)
                                }
                                handleChange(props)
                                onGlobalUpdate()
                              }}
                              className={[classes.textField]}
                              size="small"
                            />
                          ) : (
                            <Typography className={classes.text}>
                              {values.locationName || "-"}
                            </Typography>
                          )}
                        </Grid>

                        <Grid
                          item
                          lg={3}
                          md={3}
                          sm={6}
                          xs={6}
                          className={classes.divider}
                          id="id-store-mobile-view-addon"
                        >
                          <Typography
                            variant="h5"
                            className={classes.textHeader1}
                          >
                            Store Manager{" "}
                            <span style={{ color: "red" }}>
                              {edit ? "*" : ""}{" "}
                            </span>
                          </Typography>
                          {edit ? (
                            <TextField
                              defaultValue={values.locationManager}
                              value={values.locationManager}
                              variant="outlined"
                              autoComplete="off"
                              onKeyPress={(e) => handleKeyPress(e, "text")}
                              name="locationManager"
                              placeholder="Store Manager"
                              className={classes.textField}
                              error={Boolean(
                                touched.locationManager &&
                                  errors.locationManager
                              )}
                              helperText={
                                touched.locationManager &&
                                errors.locationManager
                              }
                              onBlur={handleBlur}
                              onChange={(props) => {
                                if (values.locationManager !== null) {
                                  setAllowPrompt(true)
                                }
                                handleChange(props)
                                onGlobalUpdate()
                              }}
                              size="small"
                            />
                          ) : (
                            <Typography className={classes.text}>
                              {values.locationManager
                                ? values.locationManager
                                : "-"}
                            </Typography>
                          )}
                        </Grid>
                      </Grid>

                      <Divider
                        variant="middle"
                        style={{ marginTop: "15px", marginBottom: "15px" }}
                      />

                      <Grid container direction="row">
                        <Grid
                          item
                          lg={3}
                          md={3}
                          sm={6}
                          xs={6}
                          id="id-store-mobile-view-addon"
                          className={`${
                            isTablet ? classes.noDivider : classes.divider
                          }`}
                        >
                          <Grid container direction="row">
                            <Typography
                              variant="h5"
                              className={classes.textHeader1}
                            >
                              Assistant Manager{" "}
                            </Typography>
                            {edit ? (
                              <Typography
                                variant="h5"
                                style={{
                                  color: "#9E9E9E",
                                  fontSize: "12px",
                                  fontWeight: "400",
                                  paddingLeft: "5px",
                                  marginTop: "3px",
                                }}
                              >
                                (optional)
                              </Typography>
                            ) : null}
                          </Grid>

                          {edit ? (
                            <TextField
                              defaultValue={values.assistantManager}
                              value={values.assistantManager}
                              variant="outlined"
                              autoComplete="off"
                              name="assistantManager"
                              placeholder="Assistant Manager"
                              onKeyPress={(e) => handleKeyPress(e, "text")}
                              error={Boolean(
                                touched.assistantManager &&
                                  errors.assistantManager
                              )}
                              helperText={
                                touched.assistantManager &&
                                errors.assistantManager
                              }
                              onBlur={handleBlur}
                              className={classes.textField}
                              onChange={(props) => {
                                if (values.assistantManager !== null) {
                                  setAllowPrompt(true)
                                }
                                handleChange(props)
                                onGlobalUpdate()
                              }}
                              size="small"
                            />
                          ) : (
                            <Typography className={classes.text}>
                              {values.assistantManager
                                ? values.assistantManager
                                : "-"}
                            </Typography>
                          )}
                        </Grid>
                        <Grid
                          item
                          lg={3}
                          md={6}
                          sm={6}
                          xs={12}
                          className={classes.divider}
                        >
                          <Grid container direction="row">
                            <Typography
                              variant="h5"
                              className={classes.textHeader1}
                            >
                              Support Phone Number{" "}
                            </Typography>
                          </Grid>

                          {edit ? (
                            <div
                              style={{
                                marginLeft: "15px",
                                marginBottom: "5px",
                              }}
                            >
                              <>
                                <Grid
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    marginBottom: 10,
                                  }}
                                >
                                  <Switch
                                    size="small"
                                    checked={values.allowPhoneNumber}
                                    onChange={(switchProps) => {
                                      const newValue = !values.allowPhoneNumber
                                      setFieldValue(
                                        "allowPhoneNumber",
                                        newValue
                                      )
                                      if (!newValue) {
                                        setFieldValue("phoneNumber", "")
                                      }
                                    }}
                                  />
                                  <Typography>{`${
                                    values.allowPhoneNumber
                                      ? "Enabled"
                                      : "Disabled"
                                  }`}</Typography>
                                </Grid>
                                {values.allowPhoneNumber && (
                                  <Adm.PhoneField
                                    name="phoneNumber"
                                    autoComplete="off"
                                    entity="Location"
                                    onKeyPress={(e) =>
                                      handleKeyPress(e, "number")
                                    }
                                    defaultValue={
                                      values.phoneNumber !== "0"
                                        ? values.phoneNumber.toString()
                                        : ""
                                    }
                                    className="location-base-phone-field"
                                    onUpdate={({
                                      value,
                                      dialCode,
                                      format,
                                      countryCode,
                                    }) => {
                                      const formatText =
                                        format !== undefined &&
                                        format
                                          .replace("+", "")
                                          .replace("-", "")
                                          .replaceAll(" ", "")
                                      setPhoneField({
                                        phoneCountryCode: countryCode,
                                        phoneCount: formatText.length,
                                        phoneCode: dialCode,
                                      })
                                      setFieldValue("phoneNumber", value)
                                      setFieldValue("countryCode", dialCode)
                                      onGlobalUpdate()
                                    }}
                                    defaultCountry={Utils?.JSUtils?.getPhoneCode(
                                      countryList,
                                      values?.country
                                    )}
                                    defaultErrorValue={Boolean(
                                      touched.phoneNumber && errors.phoneNumber
                                    )}
                                  />
                                )}
                              </>
                            </div>
                          ) : (
                            <>
                              {values.allowPhoneNumber ? (
                                <Typography className={classes.text}>
                                  {"+"}
                                  {displayPhoneNumber}
                                </Typography>
                              ) : (
                                <Typography className={classes.text}>
                                  {"Not Provided"}
                                </Typography>
                              )}
                            </>
                          )}
                        </Grid>
                        <Grid
                          item
                          lg={3}
                          md={6}
                          sm={6}
                          xs={12}
                          className={`${classes.divider}`}
                        >
                          <Grid container direction="row">
                            <Typography
                              variant="h5"
                              className={classes.textHeader1}
                            >
                              Support Email Address{" "}
                              <span style={{ color: "red" }}>
                                {edit ? "*" : ""}{" "}
                              </span>
                            </Typography>
                          </Grid>

                          {edit ? (
                            <TextField
                              defaultValue={values.emailAddress}
                              value={values.emailAddress}
                              variant="outlined"
                              name="emailAddress"
                              autoComplete="off"
                              placeholder="Email"
                              onKeyPress={(e) => handleKeyPress(e, "text")}
                              error={Boolean(
                                touched.emailAddress && errors.emailAddress
                              )}
                              helperText={
                                touched.emailAddress && errors.emailAddress
                              }
                              onBlur={handleBlur}
                              onChange={(props) => {
                                if (values.emailAddress !== null) {
                                  setAllowPrompt(true)
                                }
                                handleChange(props)
                                onGlobalUpdate()
                              }}
                              className={classes.textField}
                              size="small"
                            />
                          ) : (
                            <Typography className={classes.textemail}>
                              {values.emailAddress ? values.emailAddress : "-"}
                            </Typography>
                          )}
                        </Grid>

                        <Grid
                          item
                          lg={3}
                          md={3}
                          sm={6}
                          xs={6}
                          id="id-store-mobile-view-addon"
                          className={`${
                            isTablet ? classes.noDivider : classes.divider
                          }`}
                        >
                          <Grid container direction="row">
                            <Typography
                              variant="h5"
                              className={classes.textHeader1}
                            >
                              Return Policy{" "}
                              <span style={{ color: "red" }}>
                                {edit ? "*" : ""}{" "}
                              </span>
                            </Typography>
                          </Grid>

                          {edit ? (
                            <TextField
                              defaultValue={values.returnPolicy}
                              value={values.returnPolicy}
                              variant="outlined"
                              autoComplete="off"
                              name="returnPolicy"
                              placeholder="Return Policy"
                              onKeyPress={(e) => handleKeyPress(e, "text")}
                              error={Boolean(
                                touched.returnPolicy && errors.returnPolicy
                              )}
                              helperText={
                                touched.returnPolicy && errors.returnPolicy
                              }
                              onBlur={handleBlur}
                              className={classes.textField}
                              onChange={(props) => {
                                if (values.returnPolicy !== null) {
                                  setAllowPrompt(true)
                                }
                                handleChange(props)
                                onGlobalUpdate()
                              }}
                              size="small"
                            />
                          ) : (
                            <Typography className={classes.text}>
                              {values.returnPolicy ? values.returnPolicy : "-"}
                            </Typography>
                          )}
                        </Grid>
                      </Grid>

                      <Divider
                        variant="middle"
                        style={{ marginTop: "15px", marginBottom: "15px" }}
                      />

                      <Grid container direction="row">
                        {isStorageModuleAllowed ? (
                        <Grid
                          item
                          lg={3}
                          md={6}
                          sm={6}
                          xs={12}
                          className={`${classes.divider}`}
                        >
                          <Grid container direction="row">
                            <Typography
                              variant="h5"
                              className={classes.textHeader1}
                            >
                              Storage Unit{" "}
                            </Typography>
                            {edit ? (
                              <Typography
                                variant="h5"
                                style={{
                                  color: "#9E9E9E",
                                  fontSize: "12px",
                                  fontWeight: "400",
                                  paddingLeft: "5px",
                                  marginTop: "3px",
                                }}
                              >
                                (optional)
                              </Typography>
                            ) : null}
                          </Grid>

                          {edit ? (
                            <div style={{ width: "100%", paddingLeft: 20 }}>
                              <Adm.DropdownFilter
                                list={storageUnitList || []}
                                defaultValue={values?.storageUnitId}
                                selectedValue={values?.storageUnitId}
                                onChangeEvent={(e, val) => {
                                  setAnyChanges(true)
                                  setStorageAddress(val?.address || {})
                                  setFieldValue("storageUnitId", val.id)
                                  setFieldValue("isStorageunitAddress", false)
                                  if (values?.isStorageunitAddress) {
                                    setFieldValue("line1", "")
                                    setFieldValue("line2", "")
                                    setFieldValue("postalcode", "")
                                    setFieldValue("state", "")
                                    setFieldValue("city", "")
                                  }
                                }}
                                onBlur={handleBlur}
                                popupOpen={storageOpen}
                                setPopupOpen={setStorageOpen}
                                disableClearable={true}
                                classNameTextField={classes.autoCompleteHeight}
                                placeholder={"Select Storage"}
                                style={{
                                  width: "calc(100% - 40px)",
                                  backgroundColor:
                                    locationId?.length > 0 ? "#f6f6f6" : null,
                                }}
                                disabled={locationId?.length > 0 ? true : false}
                              />
                            </div>
                          ) : (
                            <Typography className={classes.textemail}>
                              {values.storageUnitId
                                ? values.storageUnitId
                                : "-"}
                            </Typography>
                          )}
                        </Grid>
                        ) : null}

                        <Grid
                          item
                          lg={3}
                          md={6}
                          sm={6}
                          xs={12}
                          className={`${classes.divider}`}
                        >
                          <Grid container direction="row">
                            <Typography
                              variant="h5"
                              className={classes.textHeader1}
                            >
                              CV Confidence Threshold{" "}
                              <span style={{ color: "red" }}>
                                {edit ? "*" : ""}{" "}
                              </span>
                            </Typography>
                          </Grid>

                          {edit ? (
                            <TextField
                              defaultValue={values.cvThreshold}
                              value={values.cvThreshold}
                              variant="outlined"
                              name="cvThreshold"
                              autoComplete="off"
                              placeholder="CV Threshold"
                              onKeyPress={(e) => handleKeyPress(e, "text")}
                              error={Boolean(
                                touched.cvThreshold && errors.cvThreshold
                              )}
                              helperText={
                                touched.cvThreshold && errors.cvThreshold
                              }
                              onBlur={handleBlur}
                              onChange={(props) => {
                                if (values.cvThreshold !== null) {
                                  setAllowPrompt(true)
                                }
                                handleChange(props)
                                onGlobalUpdate()
                              }}
                              className={classes.textField}
                              size="small"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment
                                    className={[
                                      classes.adornmentBackground,
                                      classes.adornmentEnd,
                                    ]}
                                    position="end"
                                  >
                                    <PercentageIcon />{" "}
                                  </InputAdornment>
                                ),
                              }}
                            />
                          ) : (
                            <Typography className={classes.textemail}>
                              {values.cvThreshold ? values.cvThreshold : "0"}
                              {`%`}
                            </Typography>
                          )}
                        </Grid>

                        <Grid
                          item
                          lg={3}
                          md={6}
                          sm={6}
                          xs={12}
                          className={`${classes.divider}`}
                        >
                          <Grid container direction="row">
                            <Typography
                              variant="h5"
                              className={classes.textHeader1}
                            >
                              Max Store Occupancy{" "}
                              <span style={{ color: "red" }}>
                                {edit ? "*" : ""}{" "}
                              </span>
                            </Typography>
                          </Grid>

                          {edit ? (
                            <TextField
                              defaultValue={values.maxStoreOccupancy}
                              value={values.maxStoreOccupancy}
                              variant="outlined"
                              name="maxStoreOccupancy"
                              autoComplete="off"
                              placeholder="Max Store Occupancy"
                              onKeyPress={(e) => handleKeyPress(e, "text")}
                              error={Boolean(
                                touched.maxStoreOccupancy &&
                                  errors.maxStoreOccupancy
                              )}
                              helperText={
                                touched.maxStoreOccupancy &&
                                errors.maxStoreOccupancy
                              }
                              onBlur={handleBlur}
                              onChange={(props) => {
                                if (values.maxStoreOccupancy !== null) {
                                  setAllowPrompt(true)
                                }
                                handleChange(props)
                                onGlobalUpdate()
                              }}
                              className={[
                                classes.textField,
                                classes.textFieldLeft45,
                              ]}
                              size="small"
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment
                                    className={[
                                      classes.adornmentBackground,
                                      classes.adornmentStart,
                                    ]}
                                    position="start"
                                  >
                                    <UserIcon />{" "}
                                  </InputAdornment>
                                ),
                              }}
                            />
                          ) : (
                            <Typography className={classes.textemail}>
                              {values.maxStoreOccupancy
                                ? values.maxStoreOccupancy
                                : "0"}
                            </Typography>
                          )}
                        </Grid>

                        <Grid
                          item
                          lg={3}
                          md={6}
                          sm={6}
                          xs={12}
                          className={`${classes.divider}`}
                        >
                          <Grid container direction="row">
                            <Typography
                              variant="h5"
                              className={classes.textHeader1}
                            >
                              Store Size (In Feet){" "}
                              <span style={{ color: "red" }}>
                                {edit ? "*" : ""}{" "}
                              </span>
                            </Typography>
                          </Grid>

                          {edit ? (
                            <>
                              <Grid
                                container
                                direction="row"
                                className="cls-store-mobile-view-addon"
                              >
                                <TextField
                                  type="number"
                                  placeholder="Length"
                                  variant="outlined"
                                  label="Length"
                                  inputProps={{
                                    minLength: 1,
                                  }}
                                  style={{
                                    width: "70px",
                                    marginLeft: "10px",
                                  }}
                                  defaultValue={values.locationSizeLength}
                                  value={values.locationSizeLength}
                                  error={Boolean(
                                    touched.locationSizeLength &&
                                      errors.locationSizeLength
                                  )}
                                  className={[
                                    classes.textField,
                                    "cls-store-mobile-view-txt-addon",
                                  ]}
                                  helperText={
                                    touched.locationSizeLength &&
                                    errors.locationSizeLength
                                  }
                                  onChange={(event) => {
                                    event.target.value =
                                      event.target.value === ""
                                        ? 0
                                        : parseFloat(event.target.value)
                                    if (
                                      event.target.value.length < 0 ||
                                      event.target.value.length > 10
                                    ) {
                                      return 0
                                    }
                                    setFieldValue(
                                      "locationSizeLength",
                                      event.target.value
                                    )
                                    setAnyChanges(true)
                                  }}
                                  size="small"
                                />
                                <TextField
                                  type="number"
                                  placeholder="Width"
                                  label="Width"
                                  variant="outlined"
                                  inputProps={{
                                    minLength: 1,
                                  }}
                                  error={Boolean(
                                    touched.locationSizeWidth &&
                                      errors.locationSizeWidth
                                  )}
                                  helperText={
                                    touched.locationSizeWidth &&
                                    errors.locationSizeWidth
                                  }
                                  style={{ width: "70px", marginLeft: "10px" }}
                                  defaultValue={values.locationSizeWidth}
                                  className={[
                                    classes.textField,
                                    "cls-store-mobile-view-txt-addon",
                                  ]}
                                  value={values.locationSizeWidth}
                                  onChange={(event) => {
                                    event.target.value =
                                      event.target.value === ""
                                        ? 0
                                        : parseFloat(event.target.value)
                                    if (
                                      event.target.value.length < 0 ||
                                      event.target.value.length > 10
                                    ) {
                                      return 0
                                    }

                                    setFieldValue(
                                      "locationSizeWidth",
                                      event.target.value
                                    )
                                    setAnyChanges(true)
                                  }}
                                  size="small"
                                />
                                <TextField
                                  type="number"
                                  placeholder="Height"
                                  label="Height"
                                  variant="outlined"
                                  inputProps={{
                                    minLength: 1,
                                  }}
                                  style={{ width: "70px", marginLeft: "10px" }}
                                  defaultValue={values.locationSizeHeight}
                                  value={values.locationSizeHeight}
                                  className={[
                                    classes.textField,
                                    "cls-store-mobile-view-txt-addon",
                                  ]}
                                  error={Boolean(
                                    touched.locationSizeHeight &&
                                      errors.locationSizeHeight
                                  )}
                                  helperText={
                                    touched.locationSizeHeight &&
                                    errors.locationSizeHeight
                                  }
                                  onChange={(event) => {
                                    event.target.value =
                                      event.target.value === ""
                                        ? 0
                                        : parseFloat(event.target.value)
                                    if (
                                      event.target.value.length < 0 ||
                                      event.target.value.length > 10
                                    ) {
                                      return 0
                                    }

                                    setFieldValue(
                                      "locationSizeHeight",
                                      event.target.value
                                    )
                                    setAnyChanges(true)
                                  }}
                                  size="small"
                                />
                              </Grid>
                            </>
                          ) : (
                            <>
                              <Typography className={classes.textemail}>
                                {values?.locationSizeLength
                                  ? values?.locationSizeLength
                                  : "0"}
                                ,
                                {values?.locationSizeWidth
                                  ? values?.locationSizeWidth
                                  : "0"}
                                ,
                                {values?.locationSizeHeight
                                  ? values?.locationSizeHeight
                                  : "0"}
                              </Typography>
                            </>
                          )}
                        </Grid>
                      </Grid>

                      <Divider
                        variant="middle"
                        style={{ marginTop: "15px", marginBottom: "15px" }}
                      />

                      <Grid
                        container
                        direction="row"
                        id="id-store-mobile-view-addon"
                      >
                        <Grid
                          item
                          lg={4}
                          md={4}
                          sm={6}
                          xs={6}
                          className={classes.divider}
                        >
                          <Typography
                            variant="h5"
                            className={classes.textHeader1}
                          >
                            Surveillance Camera{" "}
                            <span style={{ color: "red" }}>
                              {edit ? "*" : ""}{" "}
                            </span>
                          </Typography>
                          {edit ? (
                            <>
                              <div style={{ width: "100%", paddingLeft: 20 }}>
                                {/* <Adm.DropdownFilter
                                  list={survCameraList || []}
                                  defaultValue={values?.surveillanceCamera}
                                  selectedValue={values?.surveillanceCamera}
                                  onChangeEvent={(e, val) => {
                                    setAnyChanges(true)
                                    if (storeId?.length > 0) {
                                      setOpenConfirmationDialog(true)
                                      setSelectedCamera(val)
                                    } else {
                                      setFieldValue("surveillanceCamera", val)
                                      setSelectedCamera(val)
                                    }
                                  }}
                                  onBlur={handleBlur}
                                  popupOpen={cameraOpen}
                                  setPopupOpen={setCameraOpen}
                                  disableClearable={true}
                                  classNameTextField={
                                    classes.autoCompleteHeight
                                  }
                                  placeholder={"Select Survillence  camera"}
                                  touchedControl={touched?.surveillanceCamera}
                                  errorControl={errors?.surveillanceCamera}
                                  style={{
                                    width: "calc(100% - 40px)",
                                  }}
                                /> */}
                                <Adm.MultiListDropdown
                                  key={"name-store"}
                                  label={""}
                                  data={survCameraList}
                                  filteredItems={
                                    filteredSurveillanceCameraMultiList
                                  }
                                  searchTerm={searchTermSurveillanceCameraMulti}
                                  handleDropdownChange={
                                    handleDropdownChangeSurveillanceCameraMulti
                                  }
                                  handleSearchTerm={
                                    handleDropdownSearchTermSurveillanceCameraMulti
                                  }
                                  totalDocs={1}
                                  handleShowMore={handleShowMore}
                                  isLookup={false}
                                  searchBox={false}
                                  hideFooter={true}
                                  disabledData={
                                    disabledDataSurveillanceCameraMulti || []
                                  }
                                />
                                <div>
                                  <FormHelperText
                                    error={Boolean(
                                      touched?.surveillanceCamera &&
                                        errors?.surveillanceCamera
                                    )}
                                  >
                                    {touched.surveillanceCamera &&
                                      errors.surveillanceCamera}
                                  </FormHelperText>
                                </div>
                              </div>
                            </>
                          ) : (
                            <Typography className={classes.textemail}>
                              {_.isEmpty(values?.surveillanceCamera)
                                ? "-"
                                : values?.surveillanceCamera
                                    ?.map((itm) => itm?.name)
                                    ?.join(", ")}
                            </Typography>
                          )}
                        </Grid>
                        {values.addressCountryCode === "IN" && (
                          <Grid
                            item
                            lg={3}
                            md={3}
                            sm={6}
                            xs={6}
                            className={classes.divider}
                          >
                            <Typography
                              variant="h5"
                              className={classes.textHeader1}
                            >
                              {`GSTIN Number `}
                              <span style={{ color: "red" }}>
                                {edit ? "*" : ""}{" "}
                              </span>
                            </Typography>
                            {edit ? (
                              <>
                                <TextField
                                  defaultValue={values.GSTNumber}
                                  value={values.GSTNumber}
                                  variant="outlined"
                                  name="GSTNumber"
                                  autoComplete="off"
                                  placeholder="GSTIN Number"
                                  error={Boolean(
                                    touched.GSTNumber && errors.GSTNumber
                                  )}
                                  helperText={
                                    touched.GSTNumber && errors.GSTNumber
                                  }
                                  onKeyPress={(e) => handleKeyPress(e, "text")}
                                  onBlur={handleBlur}
                                  onChange={(props) => {
                                    if (values.GSTNumber !== null) {
                                      setAllowPrompt(true)
                                    }
                                    setFieldValue(
                                      "GSTNumber",
                                      props?.target?.value
                                    )
                                    setAnyChanges(true)
                                  }}
                                  className={[
                                    classes.textField,
                                    classes.gstNum,
                                  ]}
                                  size="small"
                                />
                              </>
                            ) : (
                              <>
                                <Typography
                                  variant="body1"
                                  style={{
                                    padding: "5px 20px",
                                    fontWeight: 500,
                                  }}
                                >
                                  {values?.GSTNumber || "-"}
                                </Typography>
                              </>
                            )}
                          </Grid>
                        )}
                        {renderStoreEntryAuthUI({ edit })}
                      </Grid>

                      <Divider className={classes.dottedDivider} />

                      <Typography
                        variant="h5"
                        style={{
                          paddingLeft: "10px",
                          fontWeight: "700",
                          fontSize: "15px",
                        }}
                      >
                        <IconButton>
                          <PlaceIcon />
                        </IconButton>
                        STORE ADDRESS INFORMATION
                      </Typography>

                      <Grid
                        container
                        direction="row"
                        style={{ padding: "10px 5px", margin: "0px" }}
                        spacing={4}
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                      >
                        <Grid
                          container
                          direction="row"
                          style={{
                            padding: "10px 5px",
                            borderRight: "1px solid #E8E8E8",
                            margin: "0px",
                          }}
                          spacing={4}
                          item
                          lg={6}
                          md={6}
                          sm={12}
                          xs={12}
                        >
                          <Grid
                            container
                            direction="row"
                            style={{ padding: "10px 5px", margin: "0px" }}
                            spacing={4}
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            {/* <Grid item lg={4} md={4} sm={4} xs={12} xl={4}> */}
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Typography
                                variant="h5"
                                className={classes.textHeader1}
                              >
                                Address Line 1{" "}
                                <span style={{ color: "red" }}>
                                  {edit ? "*" : ""}{" "}
                                </span>
                              </Typography>
                              {edit ? (
                                <TextField
                                  disabled={
                                    values?.isStorageunitAddress || false
                                  }
                                  style={{
                                    backgroundColor: values?.isStorageunitAddress
                                      ? "#f6f6f6"
                                      : null,
                                  }}
                                  defaultValue={values?.line1}
                                  value={values?.line1}
                                  variant="outlined"
                                  autoComplete="off"
                                  name="line1"
                                  placeholder="Address Line 1"
                                  onKeyPress={(e) => handleKeyPress(e, "text")}
                                  className={classes.textField}
                                  error={Boolean(touched.line1 && errors.line1)}
                                  helperText={touched.line1 && errors.line1}
                                  onBlur={handleBlur}
                                  onChange={(props) => {
                                    if (values?.line1 !== null) {
                                      setAllowPrompt(true)
                                    }
                                    handleChange(props)
                                    onGlobalUpdate()
                                  }}
                                  size="small"
                                />
                              ) : (
                                <Typography className={classes.text}>
                                  {values?.line1 || "-"}
                                </Typography>
                              )}
                            </Grid>

                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid container direction="row">
                                <Typography
                                  variant="h5"
                                  className={classes.textHeader1}
                                >
                                  Address Line 2
                                </Typography>
                                {edit ? (
                                  <Typography
                                    variant="h5"
                                    style={{
                                      color: "#9E9E9E",
                                      fontSize: "12px",
                                      fontWeight: "400",
                                      paddingLeft: "5px",
                                      marginTop: "3px",
                                    }}
                                  >
                                    (optional)
                                  </Typography>
                                ) : null}
                              </Grid>

                              {edit ? (
                                <TextField
                                  disabled={
                                    values?.isStorageunitAddress || false
                                  }
                                  style={{
                                    backgroundColor: values?.isStorageunitAddress
                                      ? "#f6f6f6"
                                      : null,
                                  }}
                                  defaultValue={values?.line2}
                                  value={values?.line2}
                                  variant="outlined"
                                  name="line2"
                                  autoComplete="off"
                                  placeholder="Address Line 2"
                                  onKeyPress={(e) => handleKeyPress(e, "text")}
                                  className={classes.textField}
                                  error={Boolean(touched.line2 && errors.line2)}
                                  helperText={touched.line2 && errors.line2}
                                  onBlur={handleBlur}
                                  onChange={(props) => {
                                    if (values?.line2 != null) {
                                      setAllowPrompt(true)
                                    }
                                    handleChange(props)
                                    onGlobalUpdate()
                                  }}
                                  size="small"
                                />
                              ) : (
                                <Typography className={classes.text}>
                                  {_.get(values, "line2", "-") || "-"}
                                </Typography>
                              )}
                            </Grid>
                          </Grid>
                          <Grid
                            container
                            direction="row"
                            style={{ padding: "10px 5px", margin: "0px" }}
                            spacing={4}
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <Grid item lg={6} md={12} sm={12} xs={12}>
                              <Typography
                                variant="h5"
                                className={classes.textHeader1}
                              >
                                Country
                                <span style={{ color: "red" }}>
                                  {edit ? "*" : ""}{" "}
                                </span>
                              </Typography>
                              {edit ? (
                                <TextField
                                  variant="outlined"
                                  size="small"
                                  className={classes.textField}
                                  type="text"
                                  autoComplete="off"
                                  name="country"
                                  placeholder="Country"
                                  value={values?.country}
                                  disabled={true}
                                  style={{ backgroundColor: "#f6f6f6" }}
                                />
                              ) : (
                                <Typography className={classes.text}>
                                  {values?.country}
                                </Typography>
                              )}
                            </Grid>
                            <Grid item lg={6} md={12} sm={12} xs={12}>
                              <Grid
                                container
                                direction="row"
                                style={{
                                  display: "flex",
                                  flexFlow: "row wrap",
                                }}
                              >
                                <Typography
                                  variant="h5"
                                  className={classes.textHeader1}
                                >
                                  State{" "}
                                  <span style={{ color: "red" }}>
                                    {edit ? "*" : ""}{" "}
                                  </span>
                                </Typography>
                                {edit &&
                                Utils?.JSUtils?.getIsUAEFlag(
                                  values?.country
                                ) ? (
                                  <Typography
                                    variant="h5"
                                    style={{
                                      color: "#9E9E9E",
                                      fontSize: "12px",
                                      fontWeight: "400",
                                      paddingLeft: "4px",
                                      marginTop: "1px",
                                      lineHeight: "13px",
                                      width: "calc(100% - 112px)",
                                    }}
                                  >
                                    State is auto-populated from Zipcode
                                  </Typography>
                                ) : null}
                              </Grid>
                              {edit ? (
                                <>
                                  {Utils?.JSUtils?.getIsUAEFlag(
                                    values?.country
                                  ) ? (
                                    <>
                                      <TextField
                                        variant="outlined"
                                        size="small"
                                        className={classes.textField}
                                        type="text"
                                        autoComplete="off"
                                        name="state"
                                        placeholder="Populate from Zipcode"
                                        value={values?.state || ""}
                                        disabled={true}
                                        error={Boolean(
                                          touched.state && errors.state
                                        )}
                                        helperText={
                                          touched.state && errors.state
                                        }
                                        style={{ backgroundColor: "#f6f6f6" }}
                                      />
                                    </>
                                  ) : (
                                    <>
                                      <Adm.DropdownFilter
                                        className="cls-tenant-state"
                                        list={getStatesList}
                                        defaultValue={values?.state}
                                        selectedValue={values?.state}
                                        onChangeEvent={(e, val) => {
                                          let stateName = val.name
                                          let cityName = val?.cities?.map(
                                            (itm) => {
                                              return { ...itm, id: itm.name }
                                            }
                                          )
                                          onUpdateCity(cityName)
                                          setAnyChanges(true)
                                          setFieldValue("state", stateName)
                                          setFieldValue("city", "")
                                        }}
                                        popupOpen={getStatesOpen}
                                        setPopupOpen={setStatesOpen}
                                        disableClearable={true}
                                        classNameTextField={
                                          classes.autoCompleteHeight
                                        }
                                        touchedControl={touched?.state}
                                        errorControl={errors?.state}
                                        placeholder={"Select State"}
                                      />
                                    </>
                                  )}
                                </>
                              ) : (
                                <Typography className={classes.text}>
                                  {values?.state || ""}
                                </Typography>
                              )}
                            </Grid>
                          </Grid>

                          <Grid
                            container
                            direction="row"
                            style={{ padding: "10px 5px", margin: "0px" }}
                            spacing={4}
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                          >
                            <Grid item lg={6} md={12} sm={12} xs={12}>
                              <Grid
                                container
                                direction="row"
                                style={{
                                  display: "flex",
                                  flexFlow: "row wrap",
                                }}
                              >
                                <Typography
                                  variant="h5"
                                  className={classes.textHeader1}
                                >
                                  City{" "}
                                  <span style={{ color: "red" }}>
                                    {edit ? "*" : ""}{" "}
                                  </span>
                                </Typography>
                                {edit &&
                                Utils?.JSUtils?.getIsUAEFlag(
                                  values?.country
                                ) ? (
                                  <Typography
                                    variant="h5"
                                    style={{
                                      color: "#9E9E9E",
                                      fontSize: "12px",
                                      fontWeight: "400",
                                      paddingLeft: "5px",
                                      marginTop: "3px",
                                      width: "calc(100% - 112px)",
                                      lineHeight: "13px",
                                    }}
                                  >
                                    City is auto-populated from Zipcode
                                  </Typography>
                                ) : null}
                              </Grid>

                              {edit ? (
                                <>
                                  {Utils?.JSUtils?.getIsUAEFlag(
                                    values?.country
                                  ) ? (
                                    <Adm.DropdownFilter
                                      list={getUserCityList}
                                      defaultValue={values.city}
                                      selectedValue={values.city}
                                      onChangeEvent={(e, val) => {
                                        setFieldValue("city", val)
                                        setAnyChanges(true)
                                      }}
                                      popupOpen={userCityOpen}
                                      setPopupOpen={setUserCityOpen}
                                      disableClearable={true}
                                      classNameTextField={
                                        classes.autoCompleteHeight
                                      }
                                      touchedControl={touched?.city}
                                      errorControl={errors?.city}
                                      placeholder={"Select City"}
                                      className={[classes.textCity]}
                                    />
                                  ) : (
                                    <Adm.DropdownFilter
                                      list={getCityList}
                                      defaultValue={values.city}
                                      selectedValue={values.city}
                                      onChangeEvent={(e, val) => {
                                        setAnyChanges(true)
                                        setFieldValue("city", val.name)
                                      }}
                                      popupOpen={getCityOpen}
                                      setPopupOpen={setCityOpen}
                                      classNameTextField={
                                        classes.autoCompleteHeight
                                      }
                                      touchedControl={touched?.city}
                                      errorControl={errors?.city}
                                      placeholder={"Select City"}
                                    />
                                  )}
                                </>
                              ) : (
                                <Typography className={classes.text}>
                                  {values?.city}
                                </Typography>
                              )}
                            </Grid>

                            <Grid item lg={6} md={12} sm={12} xs={12}>
                              <Typography
                                variant="h5"
                                className={[
                                  classes.textHeader1,
                                  classes.textCode,
                                ]}
                                style={{ paddingLeft: "22px" }}
                              >
                                Zip Code{" "}
                                {Utils?.JSUtils?.getIsUAEFlag(
                                  values?.country
                                ) && (
                                  <span style={{ color: "red" }}>
                                    {edit ? "*" : ""}{" "}
                                  </span>
                                )}
                              </Typography>
                              {edit ? (
                                <>
                                  {Utils?.JSUtils?.getIsUAEFlag(
                                    values?.country
                                  ) ? (
                                    <div
                                      style={{
                                        pointerEvents: Utils?.JSUtils?.getIsUAEFlag(
                                          values?.country
                                        )
                                          ? "auto"
                                          : "none",
                                        opacity: Utils?.JSUtils?.getIsUAEFlag(
                                          values?.country
                                        )
                                          ? "1"
                                          : "0.5",
                                      }}
                                    >
                                      <Adm.ZipCodeBox
                                        renderLabel={() => ""}
                                        errorDisable={
                                          !Utils?.JSUtils?.getIsUAEFlag(
                                            values?.country
                                          )
                                        }
                                        onVerify={ZipCodeOnVerifyCB}
                                        onChanged={ZipCodeOnChangeCB}
                                        name={"postalcode"}
                                        defaultErrorMessage={
                                          touched.postalcode &&
                                          errors.postalcode
                                        }
                                        defaultErrorFlag={
                                          touched.postalcode &&
                                          errors.postalcode
                                        }
                                        onBlur={handleBlur}
                                        defaultIsRequired={true}
                                        defaultZipCode={
                                          values?.postalcode || ""
                                        }
                                        defaultCountryCode={
                                          values?.addressCountryCode
                                        }
                                        borderRadius={"5"}
                                        height={"38"}
                                        width={"50"}
                                        classes={[classes.textCode]}
                                      />
                                    </div>
                                  ) : (
                                    <Typography className={classes.text}>
                                      {"Not Applicable"}
                                    </Typography>
                                  )}
                                </>
                              ) : (
                                <Typography className={classes.text}>
                                  {Utils?.JSUtils?.getIsUAEFlag(values?.country)
                                    ? values?.postalcode || "-"
                                    : "Not Applicable"}
                                </Typography>
                              )}
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid
                          container
                          direction="row"
                          style={{ padding: "10px 5px", margin: "0px" }}
                          spacing={4}
                          item
                          lg={6}
                          md={6}
                          sm={12}
                          xs={12}
                        >
                          <Grid
                            container
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            direction="row"
                            id="id-store-mobile-view-addon"
                            style={{
                              height: IS_MAP_ENABLE ? "unset" : "fit-content",
                            }}
                          >
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Typography
                                variant="h5"
                                className={classes.textHeader1}
                              >
                                Geographic Position{" "}
                                <span style={{ color: "red" }}>
                                  {edit ? "*" : ""}{" "}
                                </span>
                              </Typography>
                            </Grid>
                            {edit ? (
                              <>
                                {IS_MAP_ENABLE ? (
                                  <GeoLocation
                                    isView={isView}
                                    setFieldValue={setFieldValue}
                                    values={values}
                                    handleKeyPress={handleKeyPress}
                                    touched={touched}
                                    errors={errors}
                                    handleBlur={handleBlur}
                                    classes={classes}
                                    setAllowPrompt={setAllowPrompt}
                                    handleChange={handleChange}
                                    onGlobalUpdate={onGlobalUpdate}
                                  />
                                ) : (
                                  <>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                      <TextField
                                        InputLabelProps={{ shrink: true }}
                                        type="number"
                                        defaultValue={values.latitude}
                                        value={values.latitude}
                                        variant="outlined"
                                        name="latitude"
                                        label="Latitude"
                                        placeholder="Latitude"
                                        onKeyPress={(e) =>
                                          handleKeyPress(e, "text")
                                        }
                                        error={Boolean(
                                          touched.latitude && errors.latitude
                                        )}
                                        helperText={
                                          touched.latitude && errors.latitude
                                        }
                                        onBlur={handleBlur}
                                        className={classes.textField}
                                        onChange={(props) => {
                                          if (values.latitude !== null) {
                                            setAllowPrompt(true)
                                          }
                                          handleChange(props)
                                          onGlobalUpdate()
                                        }}
                                        size="small"
                                      />
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                      <TextField
                                        InputLabelProps={{ shrink: true }}
                                        type="number"
                                        defaultValue={values.longitude}
                                        value={values.longitude}
                                        variant="outlined"
                                        name="longitude"
                                        label="Longitude"
                                        placeholder="Longitude"
                                        onKeyPress={(e) =>
                                          handleKeyPress(e, "text")
                                        }
                                        error={Boolean(
                                          touched.longitude && errors.longitude
                                        )}
                                        helperText={
                                          touched.longitude && errors.longitude
                                        }
                                        onBlur={handleBlur}
                                        className={classes.textField}
                                        onChange={(props) => {
                                          if (values.longitude !== null) {
                                            setAllowPrompt(true)
                                          }
                                          handleChange(props)
                                          onGlobalUpdate()
                                        }}
                                        size="small"
                                      />
                                    </Grid>
                                  </>
                                )}
                              </>
                            ) : (
                              <Typography className={classes.text}>
                                {(values.latitude &&
                                  values.longitude &&
                                  `${values.latitude},${values.longitude}`) ||
                                  "0, 0"}
                              </Typography>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>

                      <Divider className={classes.dottedDivider} />
                      {renderPaymentInfo({
                        getAccNameLoader,
                        fetchPaymentAccount,
                        setFieldValue,
                        values,
                        classes,
                        getPHConfigOpen,
                        setPHConfigOpen,
                        getPH_GWConfigOpen,
                        setPH_GWConfigOpen,
                        getPH_ANConfigOpen,
                        setPH_ANConfigOpen,
                        getPHConfigList,
                        setPHConfigList,
                        getPH_GWConfigList,
                        setPH_GWConfigList,
                        getPH_ANConfigList,
                        setPH_ANConfigList,
                        touched,
                        handleChange,
                        errors,
                        edit,
                        setAnyChanges,
                      })}
                      <Divider className={classes.dottedDivider} />
                      <Adm.OpenDate
                        {...props}
                        setFieldValue={setFieldValue}
                        errors={errors}
                        touched={touched}
                        data={data}
                        setData={setData}
                        storeId={storeId}
                        isWriteAllowed={isWriteAllowed}
                        setAllowPrompt={setAllowPrompt}
                        isTablet={isTablet}
                        edit={edit}
                        handleBlur={handleBlur}
                        values={values}
                        timeZoneList={timeZoneList}
                        handleDateChange={handleDateChange}
                        handleTimeZoneChange={handleTimeZoneChange}
                        onGlobalUpdate={onGlobalUpdate}
                        title={"STORE DATE AND TIME INFORMATION"}
                      />
                      <Divider className={classes.dottedDivider} />
                      <Grid item lg={3} md={3} sm={6} xs={6}>
                        <Typography
                          variant="h5"
                          className={classes.textHeader1}
                        >
                          Alerts Generation
                          <span style={{ color: "red" }}>
                            {edit ? "*" : ""}{" "}
                          </span>
                        </Typography>
                        {edit ? (
                          <>
                            <Adm.DropdownFilter
                              style={{ width: "100%", paddingLeft: "30px" }}
                              list={storeScheduleList || []}
                              defaultValue={scheduleIdWithName}
                              selectedValue={scheduleIdWithName}
                              onChangeEvent={(e, val) => {
                                onGlobalUpdate()
                                setFieldValue("schedule_id", val?.id)
                              }}
                              popupOpen={scheduleOpen}
                              setPopupOpen={setScheduleOpen}
                              disableClearable={true}
                              classNameTextField={classes.autoCompleteHeight}
                              autoComplete={false}
                              touchedControl={touched?.schedule_id}
                              errorControl={errors?.schedule_id}
                              placeholder={"Select Schedule"}
                            />
                          </>
                        ) : (
                          <Typography className={classes.textemail}>
                            {scheduleIdWithName || "-"}
                          </Typography>
                        )}
                      </Grid>
                      <OperationHoursKit
                        defaultList={[values.business_hrs]}
                        edit={edit}
                        errors={errors}
                        touched={touched}
                        onGlobalUpdate={onGlobalUpdate}
                        onUpdate={(e) => {
                          onGlobalUpdate()
                          setFieldValue("business_hrs", e[0])
                        }}
                      />
                    </>
                  </FormMainWrapper>
                </>
              )
            }}
          </Formik>
        </>
      </Card>
      <>
        {alert ? (
          <Adm.SnackBar open={true} message={alertMessage} type={alertType} />
        ) : null}
      </>
    </div>
  )
}
export { LocationAddress }
export default LocationAddress
